/**
 * CompanySection — informations de l'entreprise du client (NEQ, n° de taxes…) — Batch #14.243.
 */
import { useState } from "react";
import axios from "axios";
import { Building2, Loader2, Save } from "lucide-react";
import { toast } from "@/lib/toast";
import { API, portalHeaders } from "../helpers.js";
import { Field, SectionCard, inputCls, isDemoResponse, saveBtnCls } from "./_shared";

export default function CompanySection({ company, primaryColor, onChanged }) {
  const [f, setF] = useState(company);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/portal/entrepreneur/company`, f, { headers: portalHeaders() });
      if (!isDemoResponse(res)) toast.success("Informations de l'entreprise enregistrées");
      onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };
  return (
    <SectionCard title="Mon entreprise" icon={Building2} primaryColor={primaryColor} testId="ent-portal-company">
      <p className="text-xs text-gray-500 mb-4">Ces informations apparaissent sur vos factures et servent à votre gestionnaire pour vos déclarations.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Nom de l'entreprise" className="sm:col-span-2"><input className={inputCls} value={f.business_name} onChange={(e) => set("business_name", e.target.value)} placeholder="Ex. : Les Entreprises Tremblay" data-testid="ent-portal-company-name" /></Field>
        <Field label="NEQ (Registraire des entreprises)"><input className={inputCls} value={f.neq} onChange={(e) => set("neq", e.target.value)} placeholder="1234567890" data-testid="ent-portal-company-neq" /></Field>
        <Field label="Téléphone"><input className={inputCls} value={f.phone} onChange={(e) => set("phone", e.target.value)} placeholder="514 555-0000" data-testid="ent-portal-company-phone" /></Field>
        <Field label="Numéro de TPS"><input className={inputCls} value={f.tps_number} onChange={(e) => set("tps_number", e.target.value)} placeholder="123456789 RT0001" data-testid="ent-portal-company-tps" /></Field>
        <Field label="Numéro de TVQ"><input className={inputCls} value={f.tvq_number} onChange={(e) => set("tvq_number", e.target.value)} placeholder="1234567890 TQ0001" data-testid="ent-portal-company-tvq" /></Field>
        <Field label="Adresse de l'entreprise" className="sm:col-span-2"><input className={inputCls} value={f.address} onChange={(e) => set("address", e.target.value)} placeholder="123 rue Principale, Montréal (Québec) H1A 1A1" data-testid="ent-portal-company-address" /></Field>
        <Field label="Courriel de l'entreprise" className="sm:col-span-2"><input type="email" className={inputCls} value={f.email} onChange={(e) => set("email", e.target.value)} placeholder="info@entreprise.ca" data-testid="ent-portal-company-email" /></Field>
      </div>
      <div className="flex justify-end mt-4">
        <button type="button" onClick={save} disabled={saving} className={saveBtnCls} style={{ backgroundColor: primaryColor }} data-testid="ent-portal-company-save">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Enregistrer
        </button>
      </div>
    </SectionCard>
  );
}
